import AbstractEventHookManager from "./AbstractEventHookManager";
import {videojs} from "../components/wrappers/PlayerComponentWrapper";

export class HookManager extends AbstractEventHookManager {

    constructor(protected vjs: VideoJSStatic) {
        super();
    }

    /**
     * Register a lifecycle hook on the player
     * @param hookName
     * @param hookFunction
     */
    public add<T>(hookType: T, hookFunction: Function) {
        this.vjs.hooks(this.typeToString(hookType), hookFunction);
    }

    /**
     * Add hook, which will be triggered only once
     * @param hookType
     * @param hookFunction
     */
    public addOnce<T>(hookType: T, hookFunction: Function) {
        let onceHook =  (...args:any[]):any => {
            // remove hook after first run
            this.remove(hookType, onceHook);
            // run hook and return result
            return hookFunction.apply(null, args);
        };
        this.add<T>(hookType,onceHook)
    }

    public remove<T>(hookType: T, hookFunction: Function) {
        this.vjs.removeHook(this.typeToString(hookType), hookFunction);
    }


    public getHooks<T>(hookType: T): Function[] {
        return this.vjs.hooks(this.typeToString<T>(hookType));
    }

}

/**
 * Create one hookManagerInstance instance - singleton
 * @type {HookManager}
 */
let hookManagerInstance = new HookManager(videojs);

export default hookManagerInstance;


// WEBPACK FOOTER //
// ./src/app/communication/HookManager.ts